class DropdownSelector {
  constructor() {
    this.checkSelectState();
  }

  checkSelectState() {
    // Selects
    const selectors = document.querySelectorAll(".option-selections");
    // Combo box elements that wrap selects
    const comboBox = document.querySelectorAll(".combo-box");
    // Select buttons
    const selectButtons = document.querySelectorAll("button.select");
    // Placeholder options
    const placeholders = document.querySelectorAll(
      ".select__selected-value.default-value"
    );

    // Set the number of Select elements to check against when disabling the buttons
    const selectorsLength = selectors.length;

    // Add to Cart Buttons
    const addToCart = document.getElementById("AddToCart");
    const buyItNow = document.querySelector(".shopify-payment-button");

    if (placeholders) {
      placeholders.forEach((element, index) => {
        addToCart.setAttribute("disabled", "disabled");
        buyItNow.setAttribute("disabled", "disabled");
      });
    }

    console.log('Selectors Length: ', selectorsLength);


    // Check if selectors exist
    if (selectors) {
      let selectValues = [];
      // loop through all selectors
      selectors.forEach((select, index) => {

        // Add an adventListener to each select element
        select.addEventListener("change", (event) => {

          // Push select value to new array
          selectValues.push(event.target.value);

          const checkIfSelectsChanged = () => {

            // Check array doesnt include text and has more than 1 index
            if (selectValues.length >= selectorsLength) {
              addToCart.removeAttribute("disabled");
              buyItNow.removeAttribute("disabled");
            } else {
              addToCart.setAttribute("disabled", "disabled");
              buyItNow.setAttribute("disabled", "disabled");
            }
          };

          // Set timeout to allow theme js to run first
          setTimeout(checkIfSelectsChanged, 100, "CheckIfSelectsChanged ran");
         
        });
      });
    }
  }
}
export default DropdownSelector;
